import { getDaysInMonth, getYear, setMonth } from 'date-fns';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { BirthDatePickerSelectOption, BirthDateType } from '../BirthDatePicker';

const NUMBER_OF_MONTHS = 12;
const MINIMUM_YEAR = 1900;

export const useMonthOptions = (): BirthDatePickerSelectOption[] => {
  const { t } = useTranslation(['translationReactComponents']);

  return useMemo(() => {
    const options = [];
    const date = new Date();

    for (let index = 0; index < NUMBER_OF_MONTHS; index += 1) {
      const then = setMonth(date, index);

      options.push({
        label: t('dateFormats.longMonth', { date: then }),
        value: index,
      });
    }

    return options;
  }, [t]);
};

export const useDayOptions = (value?: Partial<BirthDateType>): BirthDatePickerSelectOption[] => {
  const options: BirthDatePickerSelectOption[] = [];
  const maxDays =
    value?.year !== undefined && value.month !== undefined ? getDaysInMonth(new Date(value.year, value.month)) : 31;

  for (let day = 1; day <= maxDays; day += 1) {
    options.push({
      label: String(day),
      value: day,
    });
  }

  return options;
};

export const useYearOptions = (): BirthDatePickerSelectOption[] =>
  useMemo(() => {
    const options: BirthDatePickerSelectOption[] = [];
    const currentYear = getYear(new Date());

    for (let year = currentYear; year >= MINIMUM_YEAR; year -= 1) {
      options.push({
        label: String(year),
        value: year,
      });
    }

    return options;
  }, []);
